import React from 'react';
import PhoneLinkProps from './PhoneLink.types';
import styles from './PhoneLink.module.scss';
import Link from '../Link';

const PhoneLink = ({ children, dataCy }: PhoneLinkProps) => {
  return (
    <>
      <span data-cy={dataCy} className={styles.desktop}>
        {children}
      </span>
      <span className={styles.mobile}>
        <Link href={`tel:${children}`} target='_self' data-cy={dataCy}>
          {children}
        </Link>
      </span>
    </>
  );
};

export default PhoneLink;
